import styled from 'styled-components'

export const Page = styled.div`
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f3f3f3;
    font-family: Arial, sans-serif;
`

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const LogoBlock = styled.div`
    text-align: center;
    margin-bottom: 18px;
`

export const LogoRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 4px;
`

export const Logo = styled.img`
    width: 48px;
    height: 48px;
    object-fit: contain;
`

export const LogoText = styled.div`
    font-size: 42px;
    font-weight: 700;
    color: #0d5cab;
    letter-spacing: 1px;
`

export const Subtitle = styled.div`
    font-size: 24px;
    color: #c23b8f;
`

export const FormBox = styled.div`
    width: 360px;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    padding: 24px 20px;
    text-align: center;
`

export const LoginButton = styled.button`
    width: 100%;
    background-color: #2f61b8;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 12px 16px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #255099;
    }
`
